<template>
  <div class="archivesBody">

    <span style="margin-bottom:12px;display:flex;">
      <el-button type="primary" size="mini" @click="dialogFormVisible = true">添加</el-button>
      <el-button style="margin-left:10px" size="mini" type="primary" @click="handleUpd">更新</el-button>
      <!-- <el-button style="margin-left:10px" type="danger" @click="handleDemo">移除</el-button> -->
      <el-button style="margin-left:10px" size="mini" type="primary" @click="getList">刷新</el-button>
      <span style="margin-left: auto;">

        <el-date-picker v-model="queryYear" size="mini" type="year" placeholder="选择年" value-format="yyyy" format="yyyy"
          :clearable="false">
        </el-date-picker>
        <el-input style="width:200px; margin-left: 10px;" size="mini" placeholder="请输入变量名称" v-model="queryInput"
          clearable>
        </el-input>
      </span>
    </span>

    <el-table id="demo" v-loading="loading" ref="table"
      :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa' }"
      :data="tableData" border style="width: 100%" row-key="Id" @selection-change="handleSelectionChange">
      <template slot="empty">
        <span class="noData">
          <img src="../../assets/noData.png" alt="暂无数据">
          <span class="text">暂无数据</span>
        </span>
      </template>
      <el-table-column type="selection" width="50" align="center" fixed />
      <el-table-column v-for="(item, index) in columns" :key='index' :label="item.name" :align="item.al"
        :Width="item.width">
        <template slot-scope="scope">
          <input ref="input" v-if="flag == (item.key + scope.$index)" v-model.lazy="scope.row[item.key]"
            @blur="flag = ''" autofocus class="el-input__inner" type="number" style="height: 28px;line-height: 28px;">
          <span v-else @click="row_fn(item.key, scope.$index)">{{ scope.row[item.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]" :page-size="currentSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total" style="margin-top: 15px;">
    </el-pagination>

    <el-dialog title="添加" :visible.sync="dialogFormVisible" width="30%" @closed="handleDialogClosed">
      <el-form :model="form" ref="insertForm">
        <el-form-item label="变量名称" :label-width="formLabelWidth" required prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="年份" :label-width="formLabelWidth" required prop="year">
          <el-date-picker v-model="form.year" type="year" placeholder="选择年" value-format="yyyy">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

  export default {
    data () {

      return {
        queryYear: this.parseTime(new Date(),'{y}'),
        formLabelWidth: '120px',
        form: {
          name: '',
          year: ''
        },
        dialogFormVisible: false,
        activeName: 'rtValue',
        queryInput: '',
        loading: false,
        total: 0,
        currentPage: 1,
        currentSize: 10,
        flag: '',//需要显示的key+索引 日
        visible: false,
        list: '',
        temp: {},
        tableData: [],
        dialogVisible: false,
        columns: [{
          name: "变量名称",
          key: "name",
          width: 150,
          al: 'left'
        },{
          name: "年份",
          key: "year",
          width: 120,
          al: 'center'
        },{
          name: "value1",
          key: "value1",
          width: 120,
          al: 'center'
        },{
          name: "value2",
          key: "value2",
          width: 120,
          al: 'center'
        },{
          name: "value3",
          key: "value3",
          width: 120,
          al: 'center'
        },{
          name: "value4",
          key: "value4",
          width: 120,
          al: 'center'
        },{
          name: "value5",
          key: "value5",
          width: 120,
          al: 'center'
        },{
          name: "value6",
          key: "value6",
          width: 120,
          al: 'center'
        },{
          name: "value7",
          key: "value7",
          width: 120,
          al: 'center'
        },{
          name: "value8",
          key: "value8",
          width: 120,
          al: 'center'
        },{
          name: "value9",
          key: "value9",
          width: 120,
          al: 'center'
        },{
          name: "value10",
          key: "value10",
          width: 120,
          al: 'center'
        },{
          name: "value11",
          key: "value11",
          width: 120,
          al: 'center'
        },{
          name: "value12",
          key: "value12",
          width: 120,
          al: 'center'
        }],
        multipleSelection: []
      };
    },

    watch: {
      queryInput () {
        this.currentPage=1
        this.debounce(this.getList(),200)
      },
      queryYear () {
        this.currentPage=1
        this.debounce(this.getList(),200)
      }
    },

    mounted () {
      this.getList();//获取列表数据  

    },
    methods: {
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      handleDialogClosed () {
        this.$refs['insertForm'].resetFields()
        this.getList()
      },
      handleAdd () {
        this.$api.manufacturingKanbanApi.add(this.form,res => {
          console.log(res)
          if(res) {
            this.$message.success('添加成功')
          } else {
            this.$message.error('添加失败')
          }
          this.dialogFormVisible=false
        })
      },
      handleDel () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
      },
      handleUpd () {
        if(isempty(this.multipleSelection)) {
          this.$message.warning("请选择有效数据")
          return
        }
        this.$api.manufacturingKanbanApi.update(this.multipleSelection,res => {
          if(res) {
            this.getList()
          } else {
            this.$message.error('更新数据失败')
          }
        })
        this.$refs.table.clearSelection()
      },
      handleDemo () {
        let names='ceshi1, demo1'
        let date=new Date().getTime()
        this.$api.manufacturingKanbanApi.getListByNames(names,date,res => {
          console.log(res)
        })
      },

      debounce (func,wait,immediate) {
        let timeout,args,context,timestamp,result

        const later=function() {
          // 据上一次触发时间间隔
          const last=+new Date()-timestamp

          // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
          if(last<wait&&last>0) {
            timeout=setTimeout(later,wait-last)
          } else {
            timeout=null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if(!immediate) {
              result=func.apply(context,args)
              if(!timeout) context=args=null
            }
          }
        }

        return function(...args) {
          context=this
          timestamp=+new Date()
          const callNow=immediate&&!timeout
          // 如果延时不存在，重新设定延时
          if(!timeout) timeout=setTimeout(later,wait)
          if(callNow) {
            result=func.apply(context,args)
            context=args=null
          }
          return result
        }
      },

      handleSizeChange (s) {
        this.currentSize=s
        this.currentPage=1
        this.getList()
      },

      handleCurrentChange (p) {
        this.currentPage=p
        this.getList()
      },

      handleSelectionChange (v) {
        this.multipleSelection=v
      },

      row_fn (key,i) {
        if(!key.indexOf('variableName')!=-1) {
          this.flag=key+i;
        }
      },

      //获取列表数据
      async getList () {
        this.loading=true
        let date=this.queryYear+'-01'
        await this.$api.manufacturingKanbanApi.getList(this.currentPage,this.currentSize,this.queryInput,date,res => {
          // console.log(res)
          this.tableData=res.data
          this.total=res.total
          this.loading=false
        })
      }
    }
  };
</script>

<style lang="scss" scoped>
  .box {
    display: inline-block;
    margin-bottom: 10px;
    margin-right: 10px;
  }

  .radio_box {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    padding: 5px 3px;

    .el-radio {
      margin-right: 3px;
    }
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>